import { useIntl } from 'react-intl'

import { XMarkIcon } from '@gto/icons-react/outline/x-mark'
import { Typography } from '@gto/ui/typography'

type FacetChipProps = {
  labelId: string
  value: string
  /** Defaults to the partners list's selector, which predates the second
   *  consumer — pass a table-specific one so a test can tell them apart. */
  dataTst?: string
  onRemove: () => void
}

/**
 * Removable "Field: value" chip for active-filter rows on the admin tables.
 * The dropdowns are the INPUTS; these chips are the STATE — both visible at
 * once so the current filter state is never hidden behind a toggle.
 */
export const FacetChip = ({
  labelId,
  value,
  dataTst = 'partners-facet-chip',
  onRemove,
}: FacetChipProps) => {
  const { formatMessage } = useIntl()
  const fieldLabel = formatMessage({ id: labelId })

  return (
    <span
      className="inline-flex items-center gap-3 rounded-full border border-divider bg-paper-elevation3 py-1 pl-4 pr-2 text-xs"
      data-tst={dataTst}
    >
      <Typography
        color="text.secondary"
        component="span"
        variant="caption"
      >
        {fieldLabel}:
      </Typography>
      <Typography
        className="font-medium"
        component="span"
        variant="caption"
      >
        {value}
      </Typography>
      <button
        className="inline-flex size-8 items-center justify-center rounded-full text-text-secondary transition-colors hover:bg-paper-elevation4 hover:text-text-primary"
        type="button"
        aria-label={formatMessage(
          { id: 'admin.partners.filter.removeFacet' },
          { field: fieldLabel },
        )}
        onClick={onRemove}
      >
        <XMarkIcon
          height={12}
          width={12}
        />
      </button>
    </span>
  )
}
